import { SET_DOMAINS } from "../actions/types";

const initialState = {
  domainsList: [],
};

export default function domainsReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_DOMAINS: {
      return {
        ...state,
        domainsList: action.payload,
      };
    }
    default:
      return state;
  }
}
